export default {
      id: "links-line-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#links-line",
      toString: function () {
        return this.url;
      }
    }